import { TIPO_FLOAT2, TIPO_FLOAT_LIVRE, TIPO_MONEY, TIPO_NUMBER, TIPO_PORCENTAGEM, TIPO_PORCENTAGEM_LIVRE, TIPO_RADIOBUTTOM, TIPO_RESULTADO, CRESCIMENTO_TERMINACAO, BEZERRO, VACA, NAO_GESTANTE, GESTANTE, GESTANTE_LACTANTE, LACTANTE, ZEBUINO, CRUZADO_CORTE, CRUZADO_LEITE, CONFINAMENTO, PASTO, MACHO, MACHO_CASTRADO, FEMEA, MAX_PESO_BEZERRO, MULTIPARAS, PRIMIPARAS } from '@/utils/types.js'
import { parseString, parseMoney } from '@/utils/utils'
import Exigencias from '@/models/Exigencias'

class Animal {
    fn = null
    __data = {
      tipo: {
        tipo: TIPO_RADIOBUTTOM,
        valor: null,
        options: [
          {
            title: ['Crescimento e Terminação', 'Growing and finishing', 'Crecimiento y Terminación'],
            valor: CRESCIMENTO_TERMINACAO
          },
          {
            title: ['Vaca', 'Cow', 'Vaca'],
            valor: VACA
          },
          {
            title: ['Bezerro', 'Calf', 'Ternero'],
            valor: BEZERRO
          }
        ]
      },
      peso_corporal_inicial: {
        tipo: TIPO_NUMBER,
        valor: null,
        title: ['Peso Corporal Inicial (PCI) (Kg)', 'Initial body weight (IBW) (Kg)', 'Peso Corporal Inicial (PCI) (Kg)'],
        depende: ['tipo'], // index de dependência
        valorDepende: [[CRESCIMENTO_TERMINACAO, VACA, BEZERRO]], // valor que deve ter na dependência par aobj ser renderizado,
        maxPeso: true,
        required: true,
        maxDepende: ['peso_corporal_final'],
        min: 0
      },
      peso_corporal_final: {
        tipo: TIPO_NUMBER,
        valor: null,
        title: ['Peso Corporal Final (PCF) (Kg)', 'Final body weight (FBW) (Kg)', 'Peso Corporal Final (PCF) (Kg)'],
        depende: ['tipo'], // index de dependência
        valorDepende: [[CRESCIMENTO_TERMINACAO, VACA, BEZERRO]], // valor que deve ter na dependência par aobj ser renderizado
        maxPeso: true,
        required: true,
        minDepende: ['peso_corporal_inicial'],
        min: 0
      },

      peso_corporal_medio: {
        tipo: TIPO_RESULTADO,
        valor: 0.00,
        title: ['Peso Corporal Médio (PCM) (Kg)', 'Average body weight (ABW) (Kg)', 'Peso Corporal Promedio (PCP) (Kg)'],
        precisao: true,
        depende: ['tipo'], // index de dependência
        valorDepende: [[CRESCIMENTO_TERMINACAO, VACA, BEZERRO]], // valor que deve ter na dependência par aobj ser renderizado
        min: 0
      },
      ganho_medio_diario: {
        tipo: TIPO_FLOAT_LIVRE,
        valor: null,
        title: ['Ganho Médio Diário (GMD) (Kg)', 'Average daily gain (ADG) (Kg)', 'Ganancia Media Diaria (GMD) (Kg)'],
        precisao: true,
        depende: ['tipo'], // index de dependência
        valorDepende: [[CRESCIMENTO_TERMINACAO, VACA, BEZERRO]], // valor que deve ter na dependência par aobj ser renderizado
        required: true,
        max: 2.5,
        min: 0
      },
      // Dados Vaca
      estado_fisiologico: {
        tipo: TIPO_RADIOBUTTOM,
        valor: null,
        title: ['Escolha o estado fisiológico do animal:', 'Choose the physiologic state of the animal:', 'Elige el estado fisiológico del animal:'],
        depende: ['tipo'],
        valorDepende: [[VACA]],
        options: [
          {
            title: ['Não Gestante', 'Non Pregnant', 'No Preñada'],
            valor: NAO_GESTANTE
          },
          {
            title: ['Lactante', 'Lactating', 'En Lactancia'],
            valor: LACTANTE
          },
          {
            title: ['Gestante', 'Pregnant', 'Preñada'],
            valor: GESTANTE
          },
          {
            title: ['Gestante / Lactante', 'Pregnant / Lactating', 'Preñada / En Lactancia'],
            valor: GESTANTE_LACTANTE
          }
        ]
      },
      // Estado de parides da Vaca
      estado_parides: {
        id: "estadoParides",
        tipo: TIPO_RADIOBUTTOM,
        valor: null,
        required: true,
        title: ['Ordem de Parto:', 'Cow calving order:', 'Orden de parto de la vaca:'],
        depende: ['ganho_medio_diario', 'estado_fisiologico', 'tipo'],
        valorDepende: [undefined, [LACTANTE, GESTANTE_LACTANTE], [BEZERRO]],
        options: [
          {
            title: ['Primíparas', 'Primiparous Cow', 'Vaca Primípara'],
            valor: PRIMIPARAS,
            alt: 'primiparas_info'
          },
          {
            title: ['Multíparas', 'Multiparous Cow', 'Vaca Multípara'],
            valor: MULTIPARAS,
            alt: 'multiparas_info'
          }
        ]

      },
      // Dados crescimento e terminação
      raca: {
        tipo: TIPO_RADIOBUTTOM,
        valor: null,
        title: ['Escolha o grupo genético do animal:', 'Choose the animal breed:', 'Elige el grupo genético del animal:'],
        depende: ['tipo'],
        valorDepende: [[CRESCIMENTO_TERMINACAO]],
        options: [
          {
            title: ['Zebuíno', 'Zebu', 'Cebú'],
            valor: ZEBUINO,
            alt: 'Zebuíno (Nelore, Brahman, Guzerá, Tabapuã)'
          },
          {
            title: ['Cruzado de Corte', 'Beef Crossbred', 'Cruzado de Corte'],
            valor: CRUZADO_CORTE,
            alt: 'Cruzado de corte (Nelore x Aberdeen Angus, Brahman x Aberdeen Angus, Brahman x Hereford, Nelore x Senepol)'
          },
          {
            title: ['Cruzado de Leite', 'Dairy Crossbred', 'Cruzado de la Leche'],
            valor: CRUZADO_LEITE,
            alt: 'Cruzado de leite (Nelore x Holandesa, Nelore x Girolando, Guzerá x Girolando, Brahman x Holandesa)'
          }
        ]
      },
      regime: {
        tipo: TIPO_RADIOBUTTOM,
        valor: null,
        title: ['Escolha o sistema de produção:', 'Choose the feeding system:', 'Elija el sistema de producción:'],
        depende: ['ganho_medio_diario', 'raca'],
        valorDepende: [[''], [ZEBUINO, CRUZADO_CORTE, CRUZADO_LEITE]],
        options: [
          {
            title: ['Confinamento', 'Feedlot', 'Confinamiento'],
            valor: CONFINAMENTO,
            depende: 'raca',
            valorDepende: [ZEBUINO, CRUZADO_CORTE, CRUZADO_LEITE]
          },
          {
            title: ['Pasto', 'Pasture', 'Pasto'],
            valor: PASTO,
            depende: 'raca',
            valorDepende: [ZEBUINO]
          }
        ]
      },
      sexo: {
        tipo: TIPO_RADIOBUTTOM,
        valor: null,
        title: ['Escolha o sexo do animal:', 'Choose the gender of the animal:', 'Elige el sexo del animal:'],
        depende: ['regime'],
        valorDepende: [[CONFINAMENTO, PASTO]],
        options: [
          {
            title: ['Macho não castrado', 'Bulls', 'Toros'],
            valor: MACHO,
            depende: 'regime',
            valorDepende: [CONFINAMENTO, PASTO]
          },
          {
            title: ['Macho castrado', 'Steers', 'Novillos'],
            valor: MACHO_CASTRADO,
            depende: 'regime',
            valorDepende: [CONFINAMENTO]
          },
          {
            title: ['Fêmea', 'Heifers', 'Novillas'],
            valor: FEMEA,
            depende: 'regime',
            valorDepende: [CONFINAMENTO]
          }
        ]
      },
      numero_animais: {
        tipo: TIPO_NUMBER,
        valor: null,
        title: ['Número de Animais', 'Number of Animals', 'Número de Animales'],
        depende: ['sexo'], // index de dependência
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO]], // valor que deve ter na dependência par aobj ser renderizado
        min: 0,
        campoFinanceiro: true,
        requiredFin: true
      },
      custo_mao_de_obra: {
        tipo: TIPO_MONEY,
        valor: null,
        title: ['Custo de Mão de Obra (R$/Mês)', 'Labor cost ($/Month)', 'Costo de mano de obra ($/Mes)'],
        depende: ['sexo'], // index de dependência
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO]], // valor que deve ter na dependência par aobj ser renderizado
        campoFinanceiro: true,
        min: 0
      },
      custo_energia: {
        tipo: TIPO_MONEY,
        valor: null,
        title: ['Custo de Energia (R$/Mês)', 'Energy Cost ($/Month)', 'Costo de energía ($/mes)'],
        depende: ['sexo'], // index de dependência
        campoFinanceiro: true,
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO]] // valor que deve ter na dependência par aobj ser renderizado
      },
      custo_maquinario: {
        tipo: TIPO_MONEY,
        valor: null,
        title: ['Custo em Maquinário (R$/Mês)', 'Equipment Cost ($/Month)', 'Costo del equipo ($/Mes)'],
        depende: ['sexo'], // index de dependência
        campoFinanceiro: true,
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO]] // valor que deve ter na dependência par aobj ser renderizado
      },
      custo_medicamentos: {
        tipo: TIPO_MONEY,
        valor: null,
        title: ['Custo em Medicamentos (R$/Mês)', 'Proces. and H. Cost ($/Month)', 'Proceso. y Salud Costo ($/Mes)'],
        depende: ['sexo'], // index de dependência
        campoFinanceiro: true,
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO]] // valor que deve ter na dependência par aobj ser renderizado
      },
      custo_extra: {
        tipo: TIPO_MONEY,
        valor: null,
        title: ['Outros Custos (R$/Mês)', 'Other Costs ($/Month)', 'Otros Costos ($/Mes)'],
        depende: ['sexo', 'estado_fisiologico'], // index de dependência
        campoFinanceiro: true,
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO], []] // valor que deve ter na dependência par aobj ser renderizado
      },
      custo_total: {
        tipo: TIPO_RESULTADO,
        valor: null,
        title: ['Custos Extras Totais (R$/Mês)', 'Extra Total Costs ($/Month)', 'Costos Totales Adicionales ($/Mes)'],
        precisao: true,
        depende: ['sexo', 'estado_fisiologico'], // index de dependência
        campoFinanceiro: true,
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO], []] // valor que deve ter na dependência par aobj ser renderizado
      },
      escore_corporal: {
        tipo: TIPO_NUMBER,
        valor: 5,
        title: ['Escore Corporal', 'Body Condition Score', 'Puntuación de condición corporal'],
        precisao: true,
        depende: ['estado_fisiologico', 'estado_parides', 'tipo'], // index de dependência
        valorDepende: [[GESTANTE], [MULTIPARAS, PRIMIPARAS], []], // valor que deve ter na dependência par aobj ser renderizado
        valorExcecao: [[], [], [BEZERRO]],
        required: true,
        min: 0,
        max: 10
      },
      /*
      producao_de_leite_estimada: {
        id: 'PLeEstimada',
        tipo: TIPO_RESULTADO,
        valor: null,
        title: ['Produção de Leite da Vaca (Estimada)', 'Milk Production of the Cow (Estimated)', 'Producción de Leche de la Vaca (Estimado)'],
        precisao: true,
        depende: ['tipo', 'estado_fisiologico'], // index de dependência
        valorDepende: [[BEZERRO], [LACTANTE, GESTANTE_LACTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        required: false,
        oculta: true,
        min: 0
      },
      */
      producao_de_leite: {
        id: 'PLe',
        tipo: TIPO_FLOAT2,
        valor: null,
        title: ['Produção de Leite da Vaca', 'Milk Production of the Cow', 'Producción de Leche de la Vaca'],
        precisao: true,
        depende: ['estado_parides'], // index de dependência
        valorDepende: [[PRIMIPARAS, MULTIPARAS]], // valor que deve ter na dependência par aobj ser renderizado
        required: false,
        min: 0
      },
      semana_lactacao: {
        id: 'SL',
        tipo: TIPO_NUMBER,
        valor: 1,
        title: ['Semana de Lactação', 'Week of Lactation', 'Semana de Lactancia'],
        depende: ['estado_parides'], // index de dependência
        valorDepende: [[PRIMIPARAS, MULTIPARAS]], // valor que deve ter na dependência par aobj ser renderizado
        required: false,
        min: 0,
        max: 40,
        maxBezerro: 40
      },
      proteina_do_leite: {
        tipo: TIPO_PORCENTAGEM,
        valor: 3.56,
        title: ['Proteína do Leite', 'Milk Protein', 'Proteína láctea'],
        precisao: true,
        depende: ['estado_parides', 'estado_fisiologico'], // index de dependência
        valorDepende: [[PRIMIPARAS, MULTIPARAS], []], // valor que deve ter na dependência par aobj ser renderizado
        valorExcecao: [[], [GESTANTE]],
        // valorDepende: [[LACTANTE, GESTANTE_LACTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        required: true,
        min: 0
      },
      gordura_do_leite: {
        tipo: TIPO_PORCENTAGEM,
        valor: 4.76,
        title: ['Gordura do Leite', 'Milk Fat', 'Grasa de la leche'],
        precisao: true,
        depende: ['estado_parides', 'estado_fisiologico'], // index de dependência
        valorDepende: [[PRIMIPARAS, MULTIPARAS], []], // valor que deve ter na dependência par aobj ser renderizado
        valorExcecao: [[], [GESTANTE]],
        // valorDepende: [[LACTANTE, GESTANTE_LACTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        required: true,
        min: 0
      },
      lactose_do_leite: {
        tipo: TIPO_PORCENTAGEM,
        valor: 4.56,
        title: ['Lactose do Leite', 'Milk Lactose', 'Lactosa de la leche'],
        precisao: true,
        depende: ['estado_parides', 'estado_fisiologico'], // index de dependência
        valorDepende: [[PRIMIPARAS, MULTIPARAS], []], // valor que deve ter na dependência par aobj ser renderizado
        valorExcecao: [[], [GESTANTE]],
        // valorDepende: [[LACTANTE, GESTANTE_LACTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        required: true,
        min: 0
      },
      peso_bezerro_nascimento: {
        tipo: TIPO_FLOAT_LIVRE,
        valor: 32,
        title: ['Peso do Bezerro ao Nascer (Kg)', 'Calf Weight at Birth (Kg)', 'Peso del Ternero al Nacer (Kg)'],
        precisao: true,
        depende: ['estado_fisiologico', 'estado_parides'], // index de dependência
        valorDepende: [[GESTANTE, GESTANTE_LACTANTE], [MULTIPARAS, PRIMIPARAS]], // valor que deve ter na dependência par aobj ser renderizado
        valorExcecao: [[LACTANTE], []],
        required: true,
        min: 0,
        max: MAX_PESO_BEZERRO
      },
      dias_gestacao: {
        tipo: TIPO_NUMBER,
        valor: 210,
        title: ['Dias de Gestação', 'Days Pregnant', 'Días embarazadas'],
        depende: ['estado_fisiologico', 'estado_parides'], // index de dependência
        valorDepende: [[GESTANTE, GESTANTE_LACTANTE], [MULTIPARAS, PRIMIPARAS]], // valor que deve ter na dependência par aobj ser renderizado
        valorExcecao: [[LACTANTE], []],
        required: true,
        min: 0,
        max: 283
      },
      preco_arroba_adquirida: {
        tipo: TIPO_MONEY,
        valor: null,
        title: ['Preço de Compra (R$/@)', 'Purchase Price ($ by 15 Kg)', 'Precio de Compra ($ por 15 Kg)'],
        depende: ['sexo', 'estado_fisiologico'], // index de dependência
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO], []], // valor que deve ter na dependência par aobj ser renderizado
        campoFinanceiro: true,
        requiredFin: true
      },
      preco_venda_arroba: {
        tipo: TIPO_MONEY,
        valor: null,
        title: ['Preço de Venda (R$/@)', 'Price of Sale ($ by 15 Kg)', 'Precio de Venta ($ por 15 Kg)'],
        depende: ['sexo', 'estado_fisiologico'], // index de dependência
        precisao: false,
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO], []], // valor que deve ter na dependência par aobj ser renderizado
        campoFinanceiro: true,
        requiredFin: true
      },
      rendimento_carcaca_inicial: {
        tipo: TIPO_PORCENTAGEM_LIVRE,
        valor: null,
        title: ['Rendimento de Carcaça Inicial (%)', 'Initial Carcass Yield (%)', 'Rendimiento inicial de la canal (%)'],
        depende: ['sexo', 'estado_fisiologico'], // index de dependência
        max: 100.0,
        min: 0.0,
        precisao: false,
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO], []], // valor que deve ter na dependência par aobj ser renderizado
        campoFinanceiro: true,
        requiredFin: true
      },
      rendimento_carcaca_final: {
        tipo: TIPO_PORCENTAGEM_LIVRE,
        valor: null,
        title: ['Rendimento de Carcaça Final (%)', 'Final Carcass Yield (%)', 'Rendimiento final de la canal (%)'],
        depende: ['sexo', 'estado_fisiologico'], // index de dependência
        max: 100.0,
        min: 0.0,
        precisao: true,
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO], []], // valor que deve ter na dependência par aobj ser renderizado
        campoFinanceiro: true,
        requiredFin: true
      },
      taxa_juros_mensal: {
        tipo: TIPO_PORCENTAGEM_LIVRE,
        valor: null,
        title: ['Taxa de Juros Mensal (%)', 'Monthly Interest Rate (%)', 'Tasa de interés mensual (%)'],
        depende: ['sexo'], // index de dependência
        precisao: true,
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO]], // valor que deve ter na dependência par aobj ser renderizado
        campoFinanceiro: true,
        requiredFin: true
      },
      total_racao_a_produzir: {
        tipo: TIPO_NUMBER,
        valor: 1000,
        title: ['Total da Dieta a Produzir (Kg)', 'Total Diet to Produce', 'Dieta total para producir (Kg)'],
        depende: ['ganho_medio_diario', 'tipo', 'sexo', 'estado_fisiologico', 'estado_parides'], // index de dependência
        valorDepende: [undefined, [BEZERRO], [FEMEA, MACHO_CASTRADO, MACHO], [NAO_GESTANTE, GESTANTE], [MULTIPARAS, PRIMIPARAS]],
        required: true,
        min: 0
      }
    }
    __dataformulacao = {
      tipo: {
        tipo: TIPO_RADIOBUTTOM,
        valor: null,
        options: [
          {
            title: ['Crescimento e Terminação', 'Growing and finishing', 'Crecimiento y Terminación'],
            valor: CRESCIMENTO_TERMINACAO
          },
          {
            title: ['Vaca', 'Cow', 'Vaca'],
            valor: VACA
          },
          {
            title: ['Bezerro', 'Calf', 'Ternero'],
            valor: BEZERRO
          }
        ]
      },
      peso_corporal_inicial: {
        tipo: TIPO_NUMBER,
        valor: null,
        title: ['Peso Corporal Inicial (PCI) (Kg)', 'Initial body weight (IBW) (Kg)', 'Peso Corporal Inicial (PCI) (Kg)'],
        depende: ['tipo'], // index de dependência
        valorDepende: [[CRESCIMENTO_TERMINACAO, VACA, BEZERRO]], // valor que deve ter na dependência par aobj ser renderizado,
        maxPeso: true,
        required: true,
        maxDepende: ['peso_corporal_final'],
        min: 0
      },
      peso_corporal_final: {
        tipo: TIPO_NUMBER,
        valor: null,
        title: ['Peso Corporal Final (PCF) (Kg)', 'Final body weight (FBW) (Kg)', 'Peso Corporal Final (PCF) (Kg)'],
        depende: ['tipo'], // index de dependência
        valorDepende: [[CRESCIMENTO_TERMINACAO, VACA, BEZERRO]], // valor que deve ter na dependência par aobj ser renderizado
        maxPeso: true,
        required: true,
        minDepende: ['peso_corporal_inicial'],
        min: 0
      },

      peso_corporal_medio: {
        tipo: TIPO_RESULTADO,
        valor: 0.00,
        title: ['Peso Corporal Médio (PCM) (Kg)', 'Average body weight (ABW) (Kg)', 'Peso Corporal Promedio (PCP) (Kg)'],
        precisao: true,
        depende: ['tipo'], // index de dependência
        valorDepende: [[CRESCIMENTO_TERMINACAO, VACA, BEZERRO]], // valor que deve ter na dependência par aobj ser renderizado
        min: 0
      },
      ganho_medio_diario: {
        tipo: TIPO_FLOAT_LIVRE,
        valor: null,
        title: ['Ganho Médio Diário (GMD) (Kg)', 'Average daily gain (ADG) (Kg)', 'Ganancia Media Diaria (GMD) (Kg)'],
        precisao: true,
        depende: ['tipo'], // index de dependência
        valorDepende: [[CRESCIMENTO_TERMINACAO, VACA, BEZERRO]], // valor que deve ter na dependência par aobj ser renderizado
        required: true,
        max: 2.5,
        min: 0
      },
      // Dados Vaca
      estado_fisiologico: {
        tipo: TIPO_RADIOBUTTOM,
        valor: null,
        title: ['Escolha o estado fisiológico do animal:', 'Choose the physiologic state of the animal:', 'Elige el estado fisiológico del animal:'],
        depende: ['ganho_medio_diario', 'tipo'],
        valorDepende: [undefined, [VACA]],
        options: [
          {
            title: ['Não Gestante', 'Non Pregnant', 'No Preñada'],
            valor: NAO_GESTANTE
          },
          {
            title: ['Lactante', 'Lactating', 'En Lactancia'],
            valor: LACTANTE
          },
          {
            title: ['Gestante', 'Pregnant', 'Preñada'],
            valor: GESTANTE
          },
          {
            title: ['Gestante / Lactante', 'Pregnant / Lactating', 'Preñada / En Lactancia'],
            valor: GESTANTE_LACTANTE
          }
        ]
      },
      // Estado de parides da Vaca
      estado_parides: {
        id: "estadoParides",
        tipo: TIPO_RADIOBUTTOM,
        valor: null,
        title: ['Ordem de Parto:', 'Cow calving order:', 'Orden de parto de la vaca:'],
        depende: ['ganho_medio_diario', 'estado_fisiologico', 'tipo'],
        valorDepende: [undefined, [LACTANTE, GESTANTE_LACTANTE], [BEZERRO]],
        options: [
          {
            title: ['Primíparas', 'Primiparous Cow', 'Vaca Primípara'],
            valor: PRIMIPARAS,
            alt: 'primiparas_info'
          },
          {
            title: ['Multíparas', 'Multiparous Cow', 'Vaca Multípara'],
            valor: MULTIPARAS,
            alt: 'multiparas_info'
          }
        ]

      },
      // Dados crescimento e terminação
      raca: {
        tipo: TIPO_RADIOBUTTOM,
        valor: null,
        title: ['Escolha o grupo genético do animal:', 'Choose the animal breed:', 'Elige el grupo genético del animal:'],
        depende: ['ganho_medio_diario', 'tipo'],
        valorDepende: [undefined, [CRESCIMENTO_TERMINACAO]],
        options: [
          {
            title: ['Zebuíno', 'Zebu', 'Cebú'],
            valor: ZEBUINO,
            alt: 'zebu_info'
          },
          {
            title: ['Cruzado de Corte', 'Beef Crossbred', 'Cruzado de Corte'],
            valor: CRUZADO_CORTE,
            alt: 'cruzado_corte_info'
          },
          {
            title: ['Cruzado de Leite', 'Dairy Crossbred', 'Cruzado de la Leche'],
            valor: CRUZADO_LEITE,
            alt: 'cruzado_leite_info'
          }
        ]
      },
      regime: {
        tipo: TIPO_RADIOBUTTOM,
        valor: null,
        title: ['Escolha o sistema de produção:', 'Choose the feeding system:', 'Elija el sistema de producción:'],
        depende: ['raca'],
        valorDepende: [[ZEBUINO, CRUZADO_CORTE, CRUZADO_LEITE]],
        options: [
          {
            title: ['Confinamento', 'Feedlot', 'Confinamiento'],
            valor: CONFINAMENTO,
            depende: 'raca',
            valorDepende: [ZEBUINO, CRUZADO_CORTE, CRUZADO_LEITE]
          },
          {
            title: ['Pasto', 'Pasture', 'Pasto'],
            valor: PASTO,
            depende: 'raca',
            valorDepende: [ZEBUINO]
          }
        ]
      },
      sexo: {
        tipo: TIPO_RADIOBUTTOM,
        valor: null,
        title: ['Escolha o sexo do animal:', 'Choose the gender of the animal:', 'Elige el sexo del animal:'],
        depende: ['regime'],
        valorDepende: [[CONFINAMENTO, PASTO]],
        options: [
          {
            title: ['Macho não castrado', 'Bulls', 'Toros'],
            valor: MACHO,
            depende: 'regime',
            valorDepende: [CONFINAMENTO, PASTO]
          },
          {
            title: ['Macho castrado', 'Steers', 'Novillos'],
            valor: MACHO_CASTRADO,
            depende: 'regime',
            valorDepende: [CONFINAMENTO]
          },
          {
            title: ['Fêmea', 'Heifers', 'Novillas'],
            valor: FEMEA,
            depende: 'regime',
            valorDepende: [CONFINAMENTO]
          }
        ]
      },
      escore_corporal: {
        tipo: TIPO_NUMBER,
        valor: 5,
        title: ['Escore Corporal', 'Body Condition Score', 'Puntuación de condición corporal'],
        precisao: true,
        depende: ['estado_fisiologico', 'tipo', 'estado_parides'], // index de dependência
        valorDepende: [[GESTANTE, NAO_GESTANTE], [], [MULTIPARAS, PRIMIPARAS]], // valor que deve ter na dependência par aobj ser renderizado
        valorExcecao: [[], [BEZERRO], []],
        required: true,
        min: 0,
        max: 10
      },
      peso_bezerro_nascimento: {
        tipo: TIPO_FLOAT_LIVRE,
        valor: 32,
        title: ['Peso do Bezerro ao Nascer (Kg)', 'Calf Weight at Birth (Kg)', 'Peso del Ternero al Nacer (Kg)'],
        precisao: true,
        depende: ['estado_fisiologico', 'tipo', 'estado_parides'], // index de dependência
        valorDepende: [[GESTANTE], [], [MULTIPARAS, PRIMIPARAS]], // valor que deve ter na dependência par aobj ser renderizado
        valorExcecao: [[LACTANTE], [BEZERRO], []],
        required: true,
        min: 0,
        max: MAX_PESO_BEZERRO
      },
      dias_gestacao: {
        tipo: TIPO_NUMBER,
        valor: 210,
        title: ['Dias de Gestação', 'Days Pregnant', 'Días embarazadas'],
        depende: ['estado_fisiologico', 'tipo', 'estado_parides'], // index de dependência
        valorDepende: [[GESTANTE], [], [MULTIPARAS, PRIMIPARAS]], // valor que deve ter na dependência par aobj ser renderizado
        valorExcecao: [[LACTANTE], [BEZERRO], []],
        required: true,
        min: 0,
        max: 283
      },
      semana_lactacao: {
        id: 'SL',
        tipo: TIPO_NUMBER,
        valor: null,
        title: ['Semana de Lactação', 'Week of Lactation', 'Semana de Lactancia'],
        depende: ['estado_parides'], // index de dependência
        valorDepende: [[PRIMIPARAS, MULTIPARAS]], // valor que deve ter na dependência par aobj ser renderizado
        required: false,
        min: 1,
        max: 40,
        maxBezerro: 40
      },
      /*
      producao_de_leite_estimada: {
        id: 'PLeEstimada',
        tipo: TIPO_RESULTADO,
        valor: null,
        title: ['Produção de Leite da Vaca (Estimada)', 'Milk Production of the Cow (Estimated)', 'Producción de Leche de la Vaca (Estimado)'],
        precisao: true,
        depende: ['tipo', 'estado_fisiologico'], // index de dependência
        valorDepende: [[BEZERRO], [LACTANTE, GESTANTE_LACTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        required: false,
        oculta: true,
        min: 0
      },
      */
      producao_de_leite: {
        id: 'PLe',
        tipo: TIPO_FLOAT2,
        valor: null,
        title: ['Produção de Leite da Vaca', 'Milk Production of the Cow', 'Producción de Leche de la Vaca'],
        precisao: true,
        depende: ['estado_parides'], // index de dependência
        valorDepende: [[PRIMIPARAS, MULTIPARAS]], // valor que deve ter na dependência par aobj ser renderizado
        required: false,
        min: 0
      },
      proteina_do_leite: {
        tipo: TIPO_PORCENTAGEM,
        valor: 3.56,
        title: ['Proteína do Leite', 'Milk Protein', 'Proteína láctea'],
        precisao: true,
        depende: ['tipo','estado_parides', 'estado_fisiologico'], // index de dependência
        valorDepende: [[], [PRIMIPARAS, MULTIPARAS], []], // valor que deve ter na dependência par aobj ser renderizado
        valorExcecao: [[BEZERRO], [], [GESTANTE]],
        // valorDepende: [[LACTANTE, GESTANTE_LACTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        required: true,
        min: 0
      },
      gordura_do_leite: {
        tipo: TIPO_PORCENTAGEM,
        valor: 4.76,
        title: ['Gordura do Leite', 'Milk Fat', 'Grasa de la leche'],
        precisao: true,
        depende: ['tipo','estado_parides', 'estado_fisiologico'], // index de dependência
        valorDepende: [[], [PRIMIPARAS, MULTIPARAS], []], // valor que deve ter na dependência par aobj ser renderizado
        valorExcecao: [[BEZERRO], [], [GESTANTE]],
        // valorDepende: [[LACTANTE, GESTANTE_LACTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        required: true,
        min: 0
      },
      lactose_do_leite: {
        tipo: TIPO_PORCENTAGEM,
        valor: 4.56,
        title: ['Lactose do Leite', 'Milk Lactose', 'Lactosa de la leche'],
        precisao: true,
        depende: ['tipo','estado_parides', 'estado_fisiologico'], // index de dependência
        valorDepende: [[], [PRIMIPARAS, MULTIPARAS], []], // valor que deve ter na dependência par aobj ser renderizado
        valorExcecao: [[BEZERRO], [], [GESTANTE]],
        // valorDepende: [[LACTANTE, GESTANTE_LACTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        required: true,
        min: 0
      },
      numero_animais: {
        tipo: TIPO_NUMBER,
        valor: null,
        title: ['Número de Animais', 'Number of Animals', 'Número de Animales'],
        depende: ['sexo', 'estado_fisiologico'], // index de dependência
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO], [NAO_GESTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        min: 0,
        campoFinanceiro: true,
        requiredFin: true
      },
      custo_mao_de_obra: {
        tipo: TIPO_MONEY,
        valor: null,
        title: ['Custo de Mão de Obra (R$/Mês)', 'Labor cost ($/Month)', 'Costo de mano de obra ($/Mes)'],
        depende: ['sexo', 'estado_fisiologico'], // index de dependência
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO], [NAO_GESTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        campoFinanceiro: true,
        min: 0
      },
      custo_energia: {
        tipo: TIPO_MONEY,
        valor: null,
        title: ['Custo de Energia (R$/Mês)', 'Energy Cost ($/Month)', 'Costo de energía ($/mes)'],
        depende: ['sexo', 'estado_fisiologico'], // index de dependência
        campoFinanceiro: true,
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO], [NAO_GESTANTE]] // valor que deve ter na dependência par aobj ser renderizado
      },
      custo_maquinario: {
        tipo: TIPO_MONEY,
        valor: null,
        title: ['Custo em Maquinário (R$/Mês)', 'Equipment Cost ($/Month)', 'Costo del equipo ($/Mes)'],
        depende: ['sexo', 'estado_fisiologico'], // index de dependência
        campoFinanceiro: true,
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO], [NAO_GESTANTE]] // valor que deve ter na dependência par aobj ser renderizado
      },
      custo_medicamentos: {
        tipo: TIPO_MONEY,
        valor: null,
        title: ['Custo em Medicamentos (R$/Mês)', 'Proces. and H. Cost ($/Month)', 'Proceso. y Salud Costo ($/Mes)'],
        depende: ['sexo', 'estado_fisiologico'], // index de dependência
        campoFinanceiro: true,
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO], [NAO_GESTANTE]] // valor que deve ter na dependência par aobj ser renderizado
      },
      custo_extra: {
        tipo: TIPO_MONEY,
        valor: null,
        title: ['Outros Custos (R$/Mês)', 'Other Costs ($/Month)', 'Otros Costos ($/Mes)'],
        depende: ['sexo', 'estado_fisiologico'], // index de dependência
        campoFinanceiro: true,
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO], [NAO_GESTANTE]] // valor que deve ter na dependência par aobj ser renderizado
      },
      custo_total: {
        tipo: TIPO_RESULTADO,
        valor: null,
        title: ['Custos Extras Totais (R$/Mês)', 'Extra Total Costs ($/Month)', 'Costos Totales Adicionales ($/Mes)'],
        precisao: true,
        depende: ['sexo', 'estado_fisiologico'], // index de dependência
        campoFinanceiro: true,
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO], [NAO_GESTANTE]] // valor que deve ter na dependência par aobj ser renderizado
      },
      preco_arroba_adquirida: {
        tipo: TIPO_MONEY,
        valor: null,
        title: ['Preço de Compra (R$/@)', 'Purchase Price ($ by 15 Kg)', 'Precio de Compra ($ por 15 Kg)'],
        depende: ['sexo', 'estado_fisiologico'], // index de dependência
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO], [NAO_GESTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        campoFinanceiro: true,
        requiredFin: true
      },
      preco_venda_arroba: {
        tipo: TIPO_MONEY,
        valor: null,
        title: ['Preço de Venda (R$/@)', 'Price of Sale ($ by 15 Kg)', 'Precio de Venta ($ por 15 Kg)'],
        depende: ['sexo', 'estado_fisiologico'], // index de dependência
        precisao: false,
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO], [NAO_GESTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        campoFinanceiro: true,
        requiredFin: true
      },
      rendimento_carcaca_inicial: {
        tipo: TIPO_PORCENTAGEM_LIVRE,
        valor: null,
        title: ['Rendimento de Carcaça Inicial (%)', 'Initial Carcass Yield (%)', 'Rendimiento inicial de la canal (%)'],
        depende: ['sexo', 'estado_fisiologico'], // index de dependência
        max: 100.0,
        min: 0.0,
        precisao: true,
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO], [NAO_GESTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        campoFinanceiro: true,
        requiredFin: true
      },
      rendimento_carcaca_final: {
        tipo: TIPO_PORCENTAGEM_LIVRE,
        valor: null,
        title: ['Rendimento de Carcaça Final (%)', 'Final Carcass Yield (%)', 'Rendimiento final de la canal (%)'],
        depende: ['sexo', 'estado_fisiologico'], // index de dependência
        max: 100.0,
        min: 0.0,
        precisao: true,
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO], [NAO_GESTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        campoFinanceiro: true,
        requiredFin: true
      },
      taxa_juros_mensal: {
        tipo: TIPO_PORCENTAGEM_LIVRE,
        valor: null,
        title: ['Taxa de Juros Mensal (%)', 'Monthly Interest Rate (%)', 'Tasa de interés mensual (%)'],
        depende: ['sexo', 'estado_fisiologico'], // index de dependência
        valorDepende: [[FEMEA, MACHO_CASTRADO, MACHO], [NAO_GESTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        precisao: true,
        campoFinanceiro: true,
        requiredFin: true
      },
      total_racao_a_produzir: {
        tipo: TIPO_NUMBER,
        valor: 1000,
        title: ['Total da Dieta a Produzir (Kg)', 'Total Diet to Produce', 'Dieta total para producir (Kg)'],
        depende: ['ganho_medio_diario', 'tipo', 'sexo', 'estado_fisiologico', 'estado_parides'], // index de dependência
        valorDepende: [undefined, [BEZERRO], [FEMEA, MACHO_CASTRADO, MACHO], [NAO_GESTANTE, GESTANTE], [MULTIPARAS, PRIMIPARAS]],
        required: true,
        min: 0
      }
    }
    __datapredicao = {
      tipo: {
        tipo: TIPO_RADIOBUTTOM,
        valor: CRESCIMENTO_TERMINACAO,
        oculta: true,
        options: [
          {
            title: ['Crescimento e Terminação', 'Growing and finishing', 'Crecimiento y Terminación'],
            valor: CRESCIMENTO_TERMINACAO
          },
          {
            title: ['Vaca', 'Cow', 'Vaca'],
            valor: VACA
          },
          {
            title: ['Bezerro', 'Calf', 'Ternero'],
            valor: BEZERRO
          }
        ]
      },
      peso_corporal_medio: {
        tipo: TIPO_FLOAT_LIVRE,
        valor: null,
        title: ['Peso Corporal Médio (PCM) (Kg)', 'Average body weight (ABW) (Kg)', 'Peso Corporal Promedio (PCP) (Kg)'],
        precisao: true,
        maxPeso: true,
        required: true,
        depende: ['tipo'], // index de dependência
        valorDepende: [[CRESCIMENTO_TERMINACAO, VACA, BEZERRO]], // valor que deve ter na dependência par aobj ser renderizado
        min: 0
      },
      ganho_medio_diario: {
        tipo: TIPO_FLOAT_LIVRE,
        valor: null,
        title: ['Ganho Médio Diário (GMD) (Kg)', 'Average daily gain (ADG) (Kg)', 'Ganancia Media Diaria (GMD) (Kg)'],
        precisao: true,
        depende: ['tipo'], // index de dependência
        valorDepende: [[CRESCIMENTO_TERMINACAO, VACA, BEZERRO]], // valor que deve ter na dependência par aobj ser renderizado
        required: true,
        min: 0,
        max: 2.5
      },
      // Dados Vaca
      estado_fisiologico: {
        tipo: TIPO_RADIOBUTTOM,
        valor: null,
        title: ['Escolha o estado fisiológico do animal:', 'Choose the physiologic state of the animal:', 'Elige el estado fisiológico del animal:'],
        depende: ['tipo'],
        valorDepende: [[VACA]],
        options: [
          {
            title: ['Não Gestante', 'Non Pregnant', 'No Preñada'],
            valor: NAO_GESTANTE
          },
          {
            title: ['Lactante', 'Lactating', 'En Lactancia'],
            valor: LACTANTE
          },
          {
            title: ['Gestante', 'Pregnant', 'Preñada'],
            valor: GESTANTE
          },
          {
            title: ['Gestante / Lactante', 'Pregnant / Lactating', 'Preñada / En Lactancia'],
            valor: GESTANTE_LACTANTE
          }
        ]
      },
      // Estado de parides da Vaca
      estado_parides: {
        id: "estadoParides",
        tipo: TIPO_RADIOBUTTOM,
        valor: null,
        title: ['Ordem de Parto:', 'Cow calving order:', 'Orden de parto de la vaca:'],
        depende: ['ganho_medio_diario', 'estado_fisiologico', 'tipo'],
        valorDepende: [undefined, [LACTANTE, GESTANTE_LACTANTE], [BEZERRO]],
        options: [
          {
            title: ['Primíparas', 'Primiparous Cow', 'Vaca Primípara'],
            valor: PRIMIPARAS,
            alt: 'primiparas_info'
          },
          {
            title: ['Multíparas', 'Multiparous Cow', 'Vaca Multípara'],
            valor: MULTIPARAS,
            alt: 'multiparas_info'
          }
        ]

      },
      // Dados crescimento e terminação
      raca: {
        tipo: TIPO_RADIOBUTTOM,
        valor: null,
        title: ['Escolha a grupo genético do animal:', 'Choose the animal breed'],
        depende: ['ganho_medio_diario', 'tipo'],
        valorDepende: [undefined, [CRESCIMENTO_TERMINACAO]],
        options: [
          {
            title: ['Zebuíno', 'Zebu', 'Cebú'],
            valor: ZEBUINO,
            alt: 'zebu_info'
          },
          {
            title: ['Cruzado de Corte', 'Beef Crossbred', 'Cruzado de Corte'],
            valor: CRUZADO_CORTE,
            alt: 'cruzado_corte_info'
          },
          {
            title: ['Cruzado de Leite', 'Dairy Crossbred', 'Cruzado de la Leche'],
            valor: CRUZADO_LEITE,
            alt: 'cruzado_leite_info'
          }
        ]
      },
      regime: {
        tipo: TIPO_RADIOBUTTOM,
        valor: null,
        title: ['Escolha o sistema de produção:', 'Choose the feeding system:', 'Elija el sistema de producción:'],
        depende: ['raca'],
        valorDepende: [[ZEBUINO, CRUZADO_CORTE, CRUZADO_LEITE]],
        options: [
          {
            title: ['Confinamento', 'Feedlot', 'Confinamiento'],
            valor: CONFINAMENTO,
            depende: 'raca',
            valorDepende: [ZEBUINO, CRUZADO_CORTE, CRUZADO_LEITE]
          },
          {
            title: ['Pasto', 'Pasture', 'Pasto'],
            valor: PASTO,
            depende: 'raca',
            valorDepende: [ZEBUINO]
          }
        ]
      },
      sexo: {
        tipo: TIPO_RADIOBUTTOM,
        valor: null,
        title: ['Escolha o sexo do animal:', 'Choose the gender of the animal:', 'Elige el sexo del animal:'],
        depende: ['regime'],
        valorDepende: [[CONFINAMENTO, PASTO]],
        options: [
          {
            title: ['Macho não castrado', 'Bulls', 'Toros'],
            valor: MACHO,
            depende: 'regime',
            valorDepende: [CONFINAMENTO, PASTO]
          },
          {
            title: ['Macho castrado', 'Steers', 'Novillos'],
            valor: MACHO_CASTRADO,
            depende: 'regime',
            valorDepende: [CONFINAMENTO]
          },
          {
            title: ['Fêmea', 'Heifers', 'Novillas'],
            valor: FEMEA,
            depende: 'regime',
            valorDepende: [CONFINAMENTO]
          }
        ]
      },
      escore_corporal: {
        tipo: TIPO_NUMBER,
        valor: 5,
        title: ['Escore Corporal', 'Body Condition Score', 'Puntuación de condición corporal'],
        precisao: true,
        depende: ['estado_fisiologico', 'estado_parides', 'tipo'], // index de dependência
        valorDepende: [[GESTANTE], [MULTIPARAS, PRIMIPARAS], []], // valor que deve ter na dependência par aobj ser renderizado
        valorExcecao: [[LACTANTE], [], [BEZERRO]],
        required: true,
        min: 0,
        max: 10
      },
      semana_lactacao: {
        id: 'SL',
        tipo: TIPO_NUMBER,
        valor: null,
        title: ['Semana de Lactação', 'Week of Lactation', 'Semana de Lactancia'],
        depende: ['estado_parides'], // index de dependência
        valorDepende: [[PRIMIPARAS, MULTIPARAS]], // valor que deve ter na dependência par aobj ser renderizado
        required: false,
        min: 1,
        max: 40,
        maxBezerro: 40
      },
      /*
      producao_de_leite_estimada: {
        id: 'PLeEstimada',
        tipo: TIPO_RESULTADO,
        valor: null,
        title: ['Produção de Leite da Vaca (Estimada)', 'Milk Production of the Cow (Estimated)', 'Producción de Leche de la Vaca (Estimado)'],
        precisao: true,
        depende: ['tipo', 'estado_fisiologico'], // index de dependência
        valorDepende: [[BEZERRO], [LACTANTE, GESTANTE_LACTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        required: false,
        oculta: true,
        min: 0
      },
      */
      producao_de_leite: {
        id: 'PLe',
        tipo: TIPO_FLOAT_LIVRE,
        valor: null,
        title: ['Produção de Leite da Vaca', 'Milk Production of the Cow', 'Producción de Leche de la Vaca'],
        precisao: true,
        depende: ['estado_fisiologico'], // index de dependência
        valorDepende: [[LACTANTE, GESTANTE_LACTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        required: false,
        min: 0
      },
      proteina_do_leite: {
        tipo: TIPO_PORCENTAGEM,
        valor: null,
        title: ['Proteína do Leite', 'Milk Protein', 'Proteína láctea'],
        precisao: true,
        depende: ['estado_fisiologico'], // index de dependência
        valorDepende: [[LACTANTE, GESTANTE_LACTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        required: true,
        min: 0
      },
      gordura_do_leite: {
        tipo: TIPO_PORCENTAGEM,
        valor: null,
        title: ['Gordura do Leite', 'Milk Fat', 'Grasa de la leche'],
        precisao: true,
        depende: ['estado_fisiologico'], // index de dependência
        valorDepende: [[LACTANTE, GESTANTE_LACTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        required: true,
        min: 0
      },
      lactose_do_leite: {
        tipo: TIPO_PORCENTAGEM,
        valor: null,
        title: ['Lactose do Leite', 'Milk Lactose', 'Lactosa de la leche'],
        precisao: true,
        depende: ['estado_fisiologico'], // index de dependência
        valorDepende: [[LACTANTE, GESTANTE_LACTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        required: true,
        min: 0
      },
      peso_bezerro_nascimento: {
        tipo: TIPO_FLOAT_LIVRE,
        valor: 32,
        title: ['Peso do Bezerro ao Nascer (Kg)', 'Calf Weight at Birth (Kg)', 'Peso del Ternero al Nacer (Kg)'],
        precisao: true,
        depende: ['estado_fisiologico', 'estado_parides'], // index de dependência
        valorDepende: [[GESTANTE], [MULTIPARAS, PRIMIPARAS]], // valor que deve ter na dependência par aobj ser renderizado
        valorExcecao: [[LACTANTE], []],
        required: true,
        min: 0,
        max: MAX_PESO_BEZERRO
      },
      dias_gestacao: {
        tipo: TIPO_NUMBER,
        valor: 210,
        title: ['Dias de Gestação', 'Days Pregnant', 'Días embarazadas'],
        depende: ['estado_fisiologico', 'estado_parides'], // index de dependência
        valorDepende: [[GESTANTE], [MULTIPARAS, PRIMIPARAS]], // valor que deve ter na dependência par aobj ser renderizado
        valorExcecao: [[LACTANTE], []],
        required: true,
        min: 0,
        max: 283
      },
      total_racao_a_produzir: {
        tipo: TIPO_NUMBER,
        valor: 1000,
        title: ['Total da Dieta a Produzir (Kg)', 'Total Diet to Produce', 'Dieta total para producir (Kg)'],
        depende: ['ganho_medio_diario', 'tipo', 'sexo', 'estado_fisiologico', 'estado_parides'], // index de dependência
        valorDepende: [undefined, [BEZERRO], [FEMEA, MACHO_CASTRADO, MACHO], [NAO_GESTANTE, GESTANTE], [MULTIPARAS, PRIMIPARAS]],
        required: true,
        min: 0
      }
    }
    __dataexigencias = {
      tipo: {
        tipo: TIPO_RADIOBUTTOM,
        valor: null,
        options: [
          {
            title: ['Crescimento e Terminação', 'Growing and finishing', 'Crecimiento y Terminación'],
            valor: CRESCIMENTO_TERMINACAO
          },
          {
            title: ['Vaca', 'Cow', 'Vaca'],
            valor: VACA
          },
          {
            title: ['Bezerro', 'Calf', 'Ternero'],
            valor: BEZERRO
          }
        ]
      },
      peso_corporal_medio: {
        tipo: TIPO_FLOAT_LIVRE,
        valor: null,
        title: ['Peso Corporal Médio (PCM) (Kg)', 'Average body weight (ABW) (Kg)', 'Peso Corporal Promedio (PCP) (Kg)'],
        precisao: true,
        maxPeso: true,
        required: true,
        depende: ['tipo'], // index de dependência
        valorDepende: [[CRESCIMENTO_TERMINACAO, VACA, BEZERRO]], // valor que deve ter na dependência par aobj ser renderizado
        min: 0
      },
      ganho_medio_diario: {
        tipo: TIPO_FLOAT_LIVRE,
        valor: null,
        title: ['Ganho Médio Diário (GMD) (Kg)', 'Average daily gain (ADG) (Kg)', 'Ganancia Media Diaria (GMD) (Kg)'],
        precisao: true,
        depende: ['tipo'], // index de dependência
        valorDepende: [[CRESCIMENTO_TERMINACAO, VACA, BEZERRO]], // valor que deve ter na dependência par aobj ser renderizado
        required: true,
        max: 2.5
      },
      // Dados Vaca
      estado_fisiologico: {
        tipo: TIPO_RADIOBUTTOM,
        valor: null,
        title: ['Escolha o estado fisiológico do animal:', 'Choose the physiologic state of the animal:', 'Elige el estado fisiológico del animal:'],
        depende: ['ganho_medio_diario', 'tipo'],
        valorDepende: [undefined, [VACA]],
        options: [
          {
            title: ['Não Gestante', 'Non Pregnant', 'No Preñada'],
            valor: NAO_GESTANTE
          },
          {
            title: ['Lactante', 'Lactating', 'En Lactancia'],
            valor: LACTANTE
          },
          {
            title: ['Gestante', 'Pregnant', 'Preñada'],
            valor: GESTANTE
          },
          {
            title: ['Gestante / Lactante', 'Pregnant / Lactating', 'Preñada / En Lactancia'],
            valor: GESTANTE_LACTANTE
          }
        ]
      },
      // Estado de parides da Vaca
      estado_parides: {
        id: "estadoParides",
        tipo: TIPO_RADIOBUTTOM,
        valor: null,
        title: ['Ordem de Parto:', 'Cow calving order:', 'Orden de parto de la vaca:'],
        depende: ['estado_fisiologico', 'tipo'],
        valorDepende: [[LACTANTE, GESTANTE_LACTANTE], [BEZERRO]],
        options: [
          {
            title: ['Primíparas', 'Primiparous Cow', 'Vaca Primípara'],
            valor: PRIMIPARAS,
            alt: 'primiparas_info'
          },
          {
            title: ['Multíparas', 'Multiparous Cow', 'Vaca Multípara'],
            valor: MULTIPARAS,
            alt: 'multiparas_info'
          }
        ]

      },
      // Dados crescimento e terminação
      raca: {
        tipo: TIPO_RADIOBUTTOM,
        valor: null,
        title: ['Escolha o grupo genético do animal:', 'Choose the animal breed:', 'Elige el grupo genético del animal:'],
        depende: ['ganho_medio_diario', 'tipo'],
        valorDepende: [undefined, [CRESCIMENTO_TERMINACAO]],
        options: [
          {
            title: ['Zebuíno', 'Zebu', 'Cebú'],
            valor: ZEBUINO
          },
          {
            title: ['Cruzado de Corte', 'Beef Crossbred', 'Cruzado de Corte'],
            valor: CRUZADO_CORTE
          },
          {
            title: ['Cruzado de Leite', 'Dairy Crossbred', 'Cruzado de la Leche'],
            valor: CRUZADO_LEITE
          }
        ]
      },
      regime: {
        tipo: TIPO_RADIOBUTTOM,
        valor: null,
        title: ['Escolha o sistema de produção:', 'Choose the feeding system:', 'Elija el sistema de producción:'],
        depende: ['raca'],
        valorDepende: [[ZEBUINO, CRUZADO_CORTE, CRUZADO_LEITE]],
        options: [
          {
            title: ['Confinamento', 'Feedlot', 'Confinamiento'],
            valor: CONFINAMENTO,
            depende: 'raca',
            valorDepende: [ZEBUINO, CRUZADO_CORTE, CRUZADO_LEITE]
          },
          {
            title: ['Pasto', 'Pasture', 'Pasto'],
            valor: PASTO,
            depende: 'raca',
            valorDepende: [ZEBUINO]
          }
        ]
      },
      sexo: {
        tipo: TIPO_RADIOBUTTOM,
        valor: null,
        title: ['Escolha o sexo do animal:', 'Choose the gender of the animal:', 'Elige el sexo del animal:'],
        depende: ['regime'],
        valorDepende: [[CONFINAMENTO, PASTO]],
        options: [
          {
            title: ['Macho não castrado', 'Bulls', 'Toros'],
            valor: MACHO,
            depende: 'regime',
            valorDepende: [CONFINAMENTO, PASTO]
          },
          {
            title: ['Macho castrado', 'Steers', 'Novillos'],
            valor: MACHO_CASTRADO,
            depende: 'regime',
            valorDepende: [CONFINAMENTO]
          },
          {
            title: ['Fêmea', 'Heifers', 'Novillas'],
            valor: FEMEA,
            depende: 'regime',
            valorDepende: [CONFINAMENTO]
          }
        ]
      },
      escore_corporal: {
        tipo: TIPO_NUMBER,
        valor: 5,
        title: ['Escore Corporal', 'Body Condition Score', 'Puntuación de condición corporal'],
        precisao: true,
        depende: ['estado_fisiologico'], // index de dependência
        valorDepende: [[NAO_GESTANTE, GESTANTE, GESTANTE_LACTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        required: true,
        min: 0.0,
        max: 10.0
      },
      semana_lactacao: {
        id: 'SL',
        tipo: TIPO_NUMBER,
        valor: null,
        title: ['Semana de Lactação', 'Week of Lactation', 'Semana de Lactancia'],
        depende: ['tipo', 'estado_fisiologico'], // index de dependência
        valorDepende: [[BEZERRO], [LACTANTE, GESTANTE_LACTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        required: false,
        min: 1,
        max: 40,
        maxBezerro: 40
      },
      producao_de_leite: {
        tipo: TIPO_FLOAT2,
        valor: null,
        title: ['Produção de Leite da Vaca', 'Milk Production of the Cow', 'Producción de Leche de la Vaca'],
        precisao: true,
        depende: ['tipo', 'estado_fisiologico'], // index de dependência
        valorDepende: [[BEZERRO], [LACTANTE, GESTANTE_LACTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        required: false,
        min: 0
      },
      proteina_do_leite: {
        tipo: TIPO_PORCENTAGEM,
        valor: 3.56,
        title: ['Proteína do Leite', 'Milk Protein', 'Proteína láctea'],
        precisao: true,
        depende: ['estado_fisiologico'], // index de dependência
        valorDepende: [[LACTANTE, GESTANTE_LACTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        required: true,
        min: 0
      },
      gordura_do_leite: {
        tipo: TIPO_PORCENTAGEM,
        valor: 4.76,
        title: ['Gordura do Leite', 'Milk Fat', 'Grasa de la leche'],
        precisao: true,
        depende: ['estado_fisiologico'], // index de dependência
        valorDepende: [[LACTANTE, GESTANTE_LACTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        required: true,
        min: 0
      },
      lactose_do_leite: {
        tipo: TIPO_PORCENTAGEM,
        valor: 4.56,
        title: ['Lactose do Leite', 'Milk Lactose', 'Lactosa de la leche'],
        precisao: true,
        depende: ['estado_fisiologico'], // index de dependência
        valorDepende: [[LACTANTE, GESTANTE_LACTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        required: true,
        min: 0
      },
      peso_bezerro_nascimento: {
        tipo: TIPO_FLOAT_LIVRE,
        valor: 32.0,
        title: ['Peso do Bezerro ao Nascer (Kg)', 'Calf Weight at Birth (Kg)', 'Peso del Ternero al Nacer (Kg)'],
        precisao: true,
        depende: ['estado_fisiologico'], // index de dependência
        valorDepende: [[GESTANTE, GESTANTE_LACTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        required: true,
        min: 0,
        max: MAX_PESO_BEZERRO
      },
      dias_gestacao: {
        tipo: TIPO_NUMBER,
        valor: 210,
        title: ['Dias de Gestação', 'Days Pregnant', 'Días embarazadas'],
        depende: ['estado_fisiologico'], // index de dependência
        valorDepende: [[GESTANTE, GESTANTE_LACTANTE]], // valor que deve ter na dependência par aobj ser renderizado
        required: true,
        min: 0,
        max: 283
      },
      total_racao_a_produzir: {
        tipo: TIPO_RESULTADO,
        oculta: true,
        valor: 1000,
        title: ['Total da Dieta a Produzir (Kg)', 'Total Diet to Produce', 'Dieta total para producir (Kg)'],
        valorDepende: [[CRESCIMENTO_TERMINACAO, VACA, BEZERRO]], // valor que deve ter na dependência par aobj ser renderizado
        depende: ['tipo'], // index de dependência
        required: true,
        min: 0
      }
    }

    state = null
    useFormat = true
    exigencias = null
    tipo = 'FD'
    constructor (state, props) {
      var self = this
      this.state = state
      this.exigencias = new Exigencias(state, {}, this)
      self.tipo = state.app.tipo
      self.idioma = state.app.idioma
      self.strings = state.app.strings
      self.parseString = parseString
      self.parseMoney = parseMoney
      self.TIPO_FLOAT2 = TIPO_FLOAT2
      self.TIPO_FLOAT_LIVRE = TIPO_FLOAT_LIVRE
      self.TIPO_PORCENTAGEM_LIVRE = TIPO_PORCENTAGEM_LIVRE
      self.TIPO_PORCENTAGEM = TIPO_PORCENTAGEM
      self.TIPO_MONEY = TIPO_MONEY
      self.TIPO_NUMBER = TIPO_NUMBER
      self.TIPO_RESULTADO = TIPO_RESULTADO
      self.TIPO_RADIOBUTTOM = TIPO_RADIOBUTTOM
      switch (this.tipo) {
        case 'FD':
          this.__data = this.__dataformulacao
          break
        case 'PD':
          this.__data = this.__datapredicao
          break
        case 'E':
          this.__data = this.__dataexigencias
          break
      }

      for (let item in this.__data) {
        (function (fieldName) {
          Object.defineProperty(self, fieldName, {
            get: function () {
              let casas = 0
              if (!self.useFormat) return self.__data[fieldName]['valor']
              if (self.__data[fieldName]['tipo'] === self.TIPO_RADIOBUTTOM) return self.__data[fieldName]['valor']
              self.__data[fieldName]['valor'] = self.__data[fieldName]['valor'] !== null ? parseFloat(self.__data[fieldName]['valor']) : null
              if (self.__data[fieldName]['tipo'] === self.TIPO_FLOAT2 || self.__data[fieldName]['tipo'] === self.TIPO_FLOAT_LIVRE) {
                casas = 1
                if (self.__data[fieldName]['precisao'] && self.__data[fieldName]['precisao'] === true) {
                  casas = 2
                }
              }
              if (self.__data[fieldName]['precisao'] && self.__data[fieldName]['precisao'] === true) {
                casas = 2
              }
              if (self.__data[fieldName]['tipo'] === self.TIPO_MONEY || self.__data[fieldName]['tipo'] === self.TIPO_PORCENTAGEM || self.__data[fieldName]['tipo'] === self.TIPO_PORCENTAGEM_LIVRE) {
                casas = 2
              }
              let valor = (self.__data[fieldName]['valor'] === null || self.__data[fieldName]['valor'] === '') ? null : self.__data[fieldName]['valor'].toFixed(casas).replace('.', self.strings[self.idioma].separador_float)
              // eslint-disable-next-line use-isnan
              return (valor === NaN) ? null : valor
            },
            set: function (newValue) {
              if (fieldName === 'total_racao_a_produzir') {
                if (newValue === 0 || newValue === null) return
                self.__data[fieldName]['valor'] = newValue
                return
              }
              if (newValue === null || (typeof newValue === 'string' && newValue.trim() === '')) newValue = null
              switch (self.__data[fieldName].tipo) {
                case self.TIPO_RADIOBUTTOM:
                  let i = 0
                  for (let op in self.__data[fieldName].options) {
                    if (newValue === self.__data[fieldName].options[op]['valor']) {
                      i++
                    }
                  }
                  if (i === 0) {
                    return
                  }
                  break
                default:
                  if (newValue !== null) {
                    if (newValue !== '') {
                      if (isNaN(self.parseString(newValue, self.idioma))) {
                        newValue = self.parseMoney(newValue.trim(), self.idioma)
                      }
                      newValue = (typeof newValue === 'number') ? newValue : self.parseString(newValue.trim(), self.idioma)
                    }
                  }
                  break
              }
              self.__data[fieldName]['valor'] = newValue
              // self.__data['modified'] = (new Date()).getTime()
            }
          })
        })(item)
        if (props && props[item]) this[item] = props[item]['valor']
      }
    }
    getData (name = null) {
      if (name === null) {
        let data = Object.assign({}, this.__data)
        for (let d in data) {
          if (d === 'modified') continue
          data[d]['valor'] = this[d]
        }
        return data
      }
      if (this.__data[name]) {
        return this.__data[name]
      }
      return null
    }
    getMobileData () {
      let data = {}
      this.useFormat = false
      for (let d in this.__data) {
        if (d === 'modified') continue
        data[d] = this[d]
      }
      this.useFormat = true
      return data
    }
    registerNormalizer (fn) {
      this.fn = fn
    }
    // Métodos de cálculo
    _calcularPesoCorporalMedio() {
        if (this.peso_corporal_inicial && this.peso_corporal_final) {
            return (this.peso_corporal_inicial + this.peso_corporal_final) / 2
        }
        return 0
    }

    _calcularCustoTotal() {
        const custos = [
            this.custo_mao_de_obra,
            this.custo_energia,
            this.custo_maquinario,
            this.custo_medicamentos,
            this.custo_extra
        ].filter(custo => custo !== null)
        
        return custos.reduce((total, custo) => total + custo, 0)
    }

    // Métodos de validação
    validarDadosBasicos() {
        const erros = []
        
        if (!this.tipo) {
            erros.push('Tipo do animal é obrigatório')
        }
        
        if (!this.peso_corporal_inicial || this.peso_corporal_inicial <= 0) {
            erros.push('Peso corporal inicial deve ser maior que zero')
        }
        
        if (!this.ganho_medio_diario || this.ganho_medio_diario <= 0) {
            erros.push('Ganho médio diário deve ser maior que zero')
        }
        
        return erros
    }

    validarDadosVaca() {
        const erros = []
        
        if (this.tipo === 'VACA') {
            if (!this.estado_fisiologico) {
                erros.push('Estado fisiológico é obrigatório para vacas')
            }
            
            if ((this.estado_fisiologico === 'LACTANTE' || this.estado_fisiologico === 'GESTANTE_LACTANTE') && 
                !this.estado_parides) {
                erros.push('Estado de parição é obrigatório para vacas lactantes')
            }
        }
        
        return erros
    }

    // Getters para informações derivadas
    get diasParaTerminacao() {
        if (this.peso_corporal_inicial && this.peso_corporal_final && this.ganho_medio_diario) {
            return (this.peso_corporal_final - this.peso_corporal_inicial) / this.ganho_medio_diario
        }
        return null
    }

    get pesoVivoParaCarcaca() {
        if (this.peso_corporal_final && this.rendimento_carcaca_final) {
            return this.peso_corporal_final * (this.rendimento_carcaca_final / 100)
        }
        return null
    }

    // Métodos de conversão para diferentes formatos
    toJSON() {
        return {
            tipo: this.tipo,
            peso_corporal_inicial: this.peso_corporal_inicial,
            peso_corporal_final: this.peso_corporal_final,
            peso_corporal_medio: this.peso_corporal_medio,
            ganho_medio_diario: this.ganho_medio_diario,
            estado_fisiologico: this.estado_fisiologico,
            estado_parides: this.estado_parides,
            producao_de_leite: this.producao_de_leite,
            semana_lactacao: this.semana_lactacao,
            proteina_do_leite: this.proteina_do_leite,
            gordura_do_leite: this.gordura_do_leite,
            lactose_do_leite: this.lactose_do_leite,
            peso_bezerro_nascimento: this.peso_bezerro_nascimento,
            dias_gestacao: this.dias_gestacao,
            escore_corporal: this.escore_corporal,
            raca: this.raca,
            regime: this.regime,
            sexo: this.sexo,
            numero_animais: this.numero_animais,
            custo_mao_de_obra: this.custo_mao_de_obra,
            custo_energia: this.custo_energia,
            custo_maquinario: this.custo_maquinario,
            custo_medicamentos: this.custo_medicamentos,
            custo_extra: this.custo_extra,
            custo_total: this.custo_total,
            preco_arroba_adquirida: this.preco_arroba_adquirida,
            preco_venda_arroba: this.preco_venda_arroba,
            rendimento_carcaca_inicial: this.rendimento_carcaca_inicial,
            rendimento_carcaca_final: this.rendimento_carcaca_final,
            taxa_juros_mensal: this.taxa_juros_mensal,
            total_racao_a_produzir: this.total_racao_a_produzir
        }
    }

    // Método para atualizar múltiplas propriedades
    atualizarPropriedades(novasPropriedades) {
        Object.keys(novasPropriedades).forEach(propriedade => {
            if (this.hasOwnProperty(propriedade)) {
                this[propriedade] = novasPropriedades[propriedade]
            }
        })
        
        // Recalcula valores derivados
        this.peso_corporal_medio = this._calcularPesoCorporalMedio()
        this.custo_total = this._calcularCustoTotal()
    }

    // Método para resetar para valores padrão
    resetar() {
        Object.keys(this).forEach(propriedade => {
            if (propriedade !== 'tipo') {
                this[propriedade] = null
            }
        })
        
        // Restaura valores padrão
        this.proteina_do_leite = 3.56
        this.gordura_do_leite = 4.76
        this.lactose_do_leite = 4.56
        this.peso_bezerro_nascimento = 32
        this.dias_gestacao = 210
        this.escore_corporal = 5
        this.total_racao_a_produzir = 1000
    }
}
export default Animal